import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/Home.vue'
import Web from '../views/Web.vue'
import Payment from '../components/Payment/Payment.vue'
import Purchase from '../views/list/Purchase.vue'
import BudgetApply from '../views/list/BudgetApply.vue'
import BudgetApplyNew from '../views/list/BudgetApplyNew.vue'
import BudgetApplyDetail from '../views/detail/BudgetApply.vue'
import PurchaseLow from '../views/list/PurchaseLow.vue'
import PurchaseDetail from '../views/detail/Purchase.vue'
// import Detail from '../components/Payment/Detail.vue'
import MyFlow from '../views/users/MyFlow.vue'
import MyApproval from '../views/users/MyApproval.vue'
import Login from '../views/users/Login.vue'
import MarketOnline from '../views/list/MarketOnline.vue'
import MarketOffline from '../views/list/MarketOffline.vue'
import Yafang from '../views/list/Yafang.vue'
import MarketDetail from '../views/detail/Market.vue'
import Apply from '../views/list/Apply.vue'
import ApplyDetail from '../views/detail/Apply.vue'
import Test from '../views/Test.vue'
import Code from '../views/users/Code.vue'
import Administrative from '../views/list/Administrative.vue'
import Free from '../views/list/Free.vue'
import Detail from '../views/detail/Detail.vue'
import Debit from '../views/list/Debit.vue'
import DebitDetail from '../views/detail/Debit.vue'
import Rent from '../views/list/Rent.vue'
import Salary from '../views/list/Salary.vue'
import Print from '../components/detail/Print.vue'
import Refund from '../views/list/Refund.vue'
import RefundDetail from '../views/detail/Refund.vue'
// import Invoice from '../views/list/Invoice.vue'
import Invoice from '../views/list/Invoice.vue'
import InvoiceDetail from '../views/detail/Invoice.vue'
import Finance from '../views/list/Finance.vue'
import PayBack from '../views/list/PayBack.vue'
import Tax from '../views/list/Tax.vue'
import Transfer from '../views/list/Transfer.vue'
import Index from '../views/Index.vue'
import Repair from '../views/list/Repair.vue'
import WaterFee from '../views/list/WaterFee.vue'
import Flow from '../views/detail/Flow.vue'
//报表
import Report from '../views/report/Report.vue'
import CostReport from '../views/report/Cost.vue'
import IncomeReport from '../views/report/Income.vue'
import IncomeCost from '../views/report/IncomeCost.vue'
import IncomeCostHospital from '../views/report/IncomeCostHospital.vue'
import FlowCost from '../views/users/FlowCost.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/home',name: 'Home',component: Home},
  { path: '/web',name: 'Web',component: Web},
  { path: '/',name: 'Index',component: Index},
  { path: '/payment',name: 'Payment',component: Payment},
  
  { path: '/purchase',name: 'Purchase',component: Purchase},
  { path: '/purchase_low',name: 'PurchaseLow',component: PurchaseLow},
  { path: '/purchase/:id',name: 'PurchaseDetail',component: PurchaseDetail},

  //营销费用
  { path: '/market_online',name: 'MarketOnline',component: MarketOnline},
  { path: '/market_offline',name: 'MarketOffline',component: MarketOffline},
  { path: '/yafang',name: 'Yafang',component: Yafang},
  { path: '/market/:id',name: 'MarketDetail',component: MarketDetail},

  //报销
  { path: '/apply',name: 'Apply',component: Apply},
  { path: '/apply/:id',name: 'ApplyDetail',component: ApplyDetail},

  //借款
  { path: '/debit',name: 'Debit',component: Debit},
  { path: '/debit/:id',name: 'DebitDetail',component: DebitDetail},

  //装修设备房租款
  { path: '/rent',name: 'Rent',component: Rent},

  //水电房租款
  { path: '/water_fee',name: 'WaterFee',component: WaterFee},

  //维修费
  { path: '/repair',name: 'Repair',component: Repair},

  //行政费用
  { path: '/administrative',name: 'Administrative',component: Administrative},

  //税金支付
  { path: '/tax',name: 'Tax',component: Tax},

  //资金调拨
  { path: '/transfer',name: 'Transfer',component: Transfer},

  //工资薪酬
  { path: '/salary',name: 'Salary',component: Salary},

  //融资类支付
  { path: '/finance',name: 'Finance',component: Finance},

  //发票报销
  { path: '/invoice',name: 'Invoice',component: Invoice},
  { path: '/invoice/:id',name: 'InvoiceDetail',component: InvoiceDetail},

  //自由流程
  { path: '/free',name: 'Free',component: Free},
  { path: '/detail/:id',name: 'Detail',component: Detail},
  //通过审批单号获取详情
  { path: '/flow/:no',name: 'Flow',component: Flow},

  //退款
  { path: '/refund',name: 'Refund',component: Refund},
  { path: '/refund/:id',name: 'RefundDetail',component: RefundDetail},

  { path: '/payback',name: 'PayBack',component: PayBack},

  //个人中心
  { path: '/myflow', name: 'MyFlow', component: MyFlow },
  { path: '/myapproval', name: 'MyApproval', component: MyApproval },
  { path: '/login', name: 'Login', component: Login },
  { path: '/code', name: 'Code', component: Code },
  //打印
  { path: '/print/:id', name: 'Print', component: Print },
  //报表
  { path: '/report', name: 'Report', component: Report },
  { path: '/report/cost', name: 'CostReport', component: CostReport },
  { path: '/report/flow_cost', name: 'FlowCost', component: FlowCost },
  { path: '/report/income', name: 'IncomeReport', component: IncomeReport },
  { path: '/report/income_cost', name: 'IncomeCost', component: IncomeCost },
  { path: '/report/income_cost_hospital', name: 'IncomeCostHospital', component: IncomeCostHospital },

  //测试
  { path: '/test', name: 'Test', component: Test },
  //添加预算
  { path: '/budget_apply',name: 'BudgetApply',component: BudgetApply},
  { path: '/budget_apply_new',name: 'BudgetApplyNew',component: BudgetApplyNew},
  { path: '/budget_apply/:id', name: 'BudgetApplyDetail', component: BudgetApplyDetail },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
